import { ListGroup, ListGroupItem } from 'reactstrap';
type QuestionListProps = {
  qs: {
    type: 'stringArray' | 'objectArray';
    questions: string[] | { questionNum: number; questionText: string }[];
  };
};
const QuestionList = ({ qs }: QuestionListProps) => {
  return (
    <ListGroup>
      {qs.type === 'objectArray' &&
        (qs.questions as { questionNum: number; questionText: string }[]).map((el) => (
          <ListGroupItem key={el.questionNum}>
            {el.questionNum}. {el.questionText}
          </ListGroupItem>
        ))}
      {qs.type === 'stringArray' &&
        (qs.questions as string[]).map((el, idx) => (
          <ListGroupItem key={idx}>
            {isNaN(Number(el.charAt(0))) && `${idx + 1}.`} {el}
          </ListGroupItem>
        ))}
    </ListGroup>
  );
};
export default QuestionList;
